import { render } from "./LotInfo.vue?vue&type=template&id=71bb7a5a"
import script from "./LotInfo.vue?vue&type=script&lang=js"
export * from "./LotInfo.vue?vue&type=script&lang=js"

import "./LotInfo.vue?vue&type=style&index=0&id=71bb7a5a&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__